import React from "react";
import { FileText, Search, FlaskConical, BarChart3, Lock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const FeatureStrip = () => {
  const { t } = useLang();
  const items = [
    { icon: FileText, key: "origin" },
    { icon: Search, key: "treatments" },
    { icon: FlaskConical, key: "synthetics" },
    { icon: BarChart3, key: "market" },
  ];
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 border border-[#C1A661]/15 rounded-sm p-6 md:p-8 bg-[#080C17]/60">
      {items.map(({ icon: Icon, key }) => (
        <div key={key} className="flex items-start gap-4" data-testid={`feature-${key}`}>
          <Icon size={26} strokeWidth={1.2} className="text-[#C1A661] shrink-0 mt-0.5" />
          <div>
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#E2CFA4] font-medium">
              {t.features[key].title}
            </div>
            <p className="mt-1.5 text-[12px] text-[#A1A7B3] font-light leading-relaxed">
              {t.features[key].desc}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export const AccessBanner = ({ onOpenSubscribe }) => {
  const { t } = useLang();
  return (
    <button
      data-testid="access-all-btn"
      onClick={onOpenSubscribe}
      className="w-full flex items-center justify-center gap-4 rounded-sm border border-[#C1A661]/40 hover:border-[#C1A661] py-5 px-6 group transition-colors duration-200 bg-[#080C17]/40"
    >
      <Lock size={16} strokeWidth={1.4} className="text-[#C1A661]" />
      <span className="text-[12px] md:text-[13px] tracking-[0.22em] uppercase text-[#E2CFA4] group-hover:text-[#F8F5EE] text-center">
        {t.accessAll}
      </span>
    </button>
  );
};
